export default {
  methods: {
    removeAllEventListener (node, events, handler) {
      if (node && Array.isArray(events)) {
        events.forEach(el => {
          node.removeEventListener(el, handler)
        })
      }
      return events
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/removeAllEventListener.js